// Re:Focus — Drag & Drop Module
// SortableJS wrappers for column, card, and task reordering

import { loadOverrides, saveOverrides } from './storage.js';

let _navStackRef = { value: [] };
let cardSortableInstances = [];
let taskSortableInstances = [];

export function initDragDrop({ navStackRef }) {
  _navStackRef = navStackRef;
}

export function initTaskSortable(taskList) {
  if (!taskList || taskList._sortableInstance) return;
  const instance = new Sortable(taskList, {
    animation: 150, handle: '.task-handle', ghostClass: 'sortable-ghost',
    onEnd: () => saveTaskOrder()
  });
  taskList._sortableInstance = instance;
  taskSortableInstances.push(instance);
}

export function destroySortables() {
  cardSortableInstances.forEach(s => s.destroy());
  cardSortableInstances = [];
  taskSortableInstances.forEach(s => s.destroy());
  taskSortableInstances = [];
}

export function createCardSortable(container) {
  cardSortableInstances.push(
    new Sortable(container, {
      group: 'cards', animation: 150, handle: '.card-drag-handle',
      ghostClass: 'sortable-ghost', chosenClass: 'sortable-chosen', dragClass: 'sortable-drag',
      onEnd: () => saveCardOrder()
    })
  );
}

export function createColumnSortable(board) {
  new Sortable(board, {
    animation: 150,
    handle: '.col-drag-handle',
    draggable: '.column',
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    onEnd: () => {
      const ov = loadOverrides();
      ov.rootColumnOrder = Array.from(board.querySelectorAll('.column')).map(el => el.dataset.columnId);
      saveOverrides(ov);
    },
  });
}

export function saveCardOrder() {
  const ov = loadOverrides();
  if (!ov.columnOrder) ov.columnOrder = {};
  const navStack = _navStackRef.value;
  document.querySelectorAll('.column-cards').forEach(container => {
    const colId = container.dataset.columnId;
    const projectIds = Array.from(container.querySelectorAll('.card')).map(c => c.dataset.projectId);
    ov.columnOrder[colId] = projectIds;
    if (ov.addedProjects) {
      for (const pid of projectIds) {
        const added = ov.addedProjects.find(p => p.id === pid);
        if (added) added.columnId = colId;
      }
    }
    if (ov.addedChildren && navStack.length > 0) {
      const parentId = navStack[navStack.length - 1].id;
      if (ov.addedChildren[parentId]) {
        for (const pid of projectIds) {
          const added = ov.addedChildren[parentId].find(c => c.id === pid);
          if (added) added.columnId = colId;
        }
      }
    }
  });
  saveOverrides(ov);
}

export function saveTaskOrder() {
  const ov = loadOverrides();
  if (!ov.taskOrder) ov.taskOrder = {};
  document.querySelectorAll('.card-tasks-list').forEach(list => {
    const projId = list.dataset.projectId;
    const taskIds = Array.from(list.querySelectorAll('.task-item')).map(t => t.dataset.taskId);
    ov.taskOrder[projId] = taskIds;
  });
  saveOverrides(ov);
}
